module.exports = __webpack_public_path__ + "img/events-banner.87528480.jpg";